import React from 'react';

export const MainBtn = props => {
    
    return (
        <button 
            className={`formMainButton ${props.extraClasses} ${props.disabledBtn ? 'qf-disabled-btn' : ''}`} 
            onClick={props.onclick}
            disabled={!!props.disabledBtn ? props.disabledBtn : false}
        >
            {props.title}
        </button>
    );
};

export const CancelBtn = props => {
    return (
        <button className={`formCancelButton ${props.extraClasses}`} onClick={props.onclick}>
            {props.title}
        </button>
    );
};


// WEBPACK FOOTER //
// ./src/customModules/Common/form/Buttons.js